import { STANDARDS_FETCHED } from "../types";
const initialState = { section: [], introductions: []};
export default function standards(state = initialState, action = {}) {
  switch (action.type) {
    case STANDARDS_FETCHED:
      return { ...action.standards };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standards.js